<template>
    <div class="container" v-if="marketplaceFaq">
      <b-row>
        <b-col md="12" xs="12" >
          <p>
            <b>{{ $t('marketplace.faq.platform') }} :</b> 
            {{ marketplaceFaq.platform }}
          </p>
          <p>
            <b>{{ $t('marketplace.faq.title') }} :</b> 
            {{ marketplaceFaq.title }}
            </p>
          <div><b>{{ $t('marketplace.faq.content') }} :</b> </div >
          <p><span style="white-space: pre-wrap;">{{ marketplaceFaq.content }}</span>
          </p>
        </b-col>
      </b-row>
    </div>
</template>
<script>
export default {
  name: 'MarketplaceFaqDetail',
  props: {
    marketplaceFaq: {
      type: Object
    }
  }
}
</script>
